import { Group } from './Group';

export class GroupContainer<K, T> {
    private readonly _groups: Map<K | string, Group<K, T>>;

    constructor() {
        this._groups = new Map();
    }

    public add(header: K, item: T, key: string | undefined) {
        const group = this._groups.get(key || header);

        if (group) {
            group.push(item);
        } else {
            this._groups.set(key || header, new Group(header, [item]));
        }
    }

    public map<R>(callback: (group: Group<K, T>) => R): R[] {
        return Array.from(this._groups.values()).map(callback);
    }
}
